export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">APP下载</h2>
            <p className="text-sm text-foreground-500">随时随地吃瓜，爆料不错过</p>
          </div>
          <div className="max-w-2xl mx-auto">
            <div className="bg-background-50 rounded-lg border border-background-300/40 p-8">
              <div className="flex flex-col lg:flex-row items-center gap-8">
                <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-primary-500/20 to-accent-500/10 flex items-center justify-center flex-shrink-0 border border-primary-500/20">
                  <i className="ri-eye-line text-5xl text-primary-400"></i>
                </div>
                <div className="flex-1 text-center lg:text-left">
                  <h3 className="font-heading text-xl text-foreground-950 mb-3">51暗网 APP</h3>
                  <p className="text-sm text-foreground-500 mb-6 leading-relaxed">
                    支持安卓与iOS双平台，具备实时推送、离线阅读、夜间模式等特色功能。
                    安装后即可第一时间接收最新爆料通知，吃瓜快人一步。
                  </p>
                  <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                    <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-400 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm cursor-pointer">
                      <i className="ri-android-line"></i>
                      Android 下载
                    </a>
                    <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-600 hover:text-foreground-800 border border-background-300/60 rounded-lg transition-all duration-200 text-sm cursor-pointer">
                      <i className="ri-apple-line"></i>
                      iOS 下载
                    </a>
                  </div>
                  <p className="text-xs text-foreground-400 mt-4">版本 v3.2.1 · 更新时间 2025年7月18日 · 已通过安全检测</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}